export default __webpack_public_path__ + "static/media/pancreas1.b10703d1.jpg";